import { useCallback } from "react";

import { createFiltersFromFilterData } from "../../../../utils/formViews";

import { Filter, ComplexFilter } from "../../../common/hooks/useLocalTable";
import useEntityFormViewTable from "../../../common/hooks/useEntityFormViewTable";
// import RiskLevelsActions from "components/admin/transaction/risk-levels/risk-levels-actions";

const getFilters = (searchString, filterData) => {
    const filters = [];

    if (searchString) {
        filters.push(
            new ComplexFilter([new Filter("description", Filter.CO, searchString), new Filter("profile", Filter.CO, searchString)], ComplexFilter.OR)
        );
    }

    if (filterData) {
        const createdFilters = createFiltersFromFilterData(filterData);
        filters.push(...createdFilters);
    }
    return filters;
};

const useCriticalProfilesTable = (profiles) => {
    const getDialogFilters = useCallback(
        async ({ field, search = "" }) => {
            const lowerSearch = search.toLowerCase();
            let keys;

            switch (field) {
                case "profile": {
                    keys = profiles.filter(({ profile }) => profile?.toLowerCase().includes(lowerSearch)).map(({ profile }) => profile);
                    break;
                }
                case "system": {
                    keys = profiles.filter(({ system }) => system?.toLowerCase().includes(lowerSearch)).map(({ system }) => system);
                    break;
                }
            }

            const uniqueKeys = [...new Set(keys)];
            const rows = uniqueKeys.map((key) => ({ key, text: key }));
            return { rows, total: rows?.length };
        },
        [profiles]
    );

    const viewTable = useEntityFormViewTable(profiles, getFilters);

    return {
        ...viewTable,
        getDialogFilters,
    };
};

export default useCriticalProfilesTable;
